@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.FlyoverItem {
  border-radius: $border-radius-base;
  margin: 0 $size-XS;
  padding: 6px 8px;

  &:not(.FlyoverItem_disabled) {
    &:focus,
    &:hover {
      background: $system_gray-lighter;
    }
  }

  &:first-of-type {
    margin-top: $size-XS;
  }
  &:last-of-type {
    margin-bottom: $size-XS;
  }

  &_disabled {
    color: $system_eggplant-lightest;
  }

  &_withIcon {
    display: flex;
  }
}

.Icon {
  margin-right: $size-XS;
}
